import { get } from 'lodash'
import { email, required, ageBetween } from 'utils/validation'
import { minAge, phone } from '../../../../utils/validation'

export const asyncValidate = (val, dispatch, props) => {
  const { values } = props

  const defaultResponse = { body: { value: false } }

  const secondaryEmail = get(values, 'secondaryEmail')

  const tertiaryEmail = get(values, 'tertiaryEmail')

  const promises = Promise.all([
    props.checkEmail({ email: secondaryEmail, checkAlternativeEmails: true }).catch(() => defaultResponse),
    props.checkEmail({ email: tertiaryEmail, checkAlternativeEmails: true }).catch(() => defaultResponse)
  ])
  const EMAIL_IN_USE = {
    text: 'E-mail address is already in use.',
    intlKey: 'errors.email_address_is_in_use'
  }

  const SAME_EMAILS = {
    text: 'E-mail cannot be the same.',
    intlKey: 'errors.emails_cannot_be_same'
  }


  return promises
    .then(r => {
      const [secondaryEmailRes, tertiaryEmailRes] = r
      const errors = {
        secondaryEmail: secondaryEmailRes.body.value ? EMAIL_IN_USE : undefined,
        tertiaryEmail: tertiaryEmailRes.body.value ? EMAIL_IN_USE : undefined,
      }

      if (secondaryEmail === tertiaryEmail) {
        // eslint-disable-next-line
        throw { tertiaryEmail: SAME_EMAILS }
      }

      if (Object.values(errors).some(v => v)) {
        throw errors
      }
    })
}

export const validate = (values, props) => {
  const awardLevel = get(props, 'awards.data.awardLevel.value')

  const errors = get(props, 'isAssessor') ? {
    helpers: undefined,
    title: required(get(values, 'title')),
    email: email(get(values, 'email')),
    secondaryEmail: email(get(values, 'secondaryEmail')),
    tertiaryEmail: email(get(values, 'tertiaryEmail')),
    phone: required(get(values, 'phone')) || phone(get(values, 'phone')),
    phoneType: {
      value: required(get(values, 'phoneType.value'))
    },
    secondaryPhone: (get(values, 'secondaryPhone') !== '+') ? phone(get(values, 'secondaryPhone')) : undefined,
    birthDate: required(get(values, 'birthDate')) || minAge(get(values, 'birthDate'), 18)
  } : {
    helpers: undefined,
    phone: required(get(values, 'phone')),
    birthDate: required(get(values, 'birthDate')) ||
      ageBetween(get(values, 'birthDate'), awardLevel, {
        configuration: get(props, 'configuration.values'),
        awardConfigurations: []
      }),
    email: email(get(values, 'secondaryEmail'))
  }

  return errors
}
